// extracted by mini-css-extract-plugin
export default {"dateRange":"DateRange_dateRange__7Uj19","dateText":"DateRange_dateText__FLrA8"};